// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__QudcA","checkbox-span":"checkbox_checkbox-span__T70yr","checked":"checkbox_checked__Ii3z9"};